export default {
  select: 'id,instanceData',
  expand: {
    form: {
      select: 'id,name,publicStyleTemplate,title,description,logoUrl,mainColor,fontUrl',
      expand: {
        fields: {
          filter: 'isActive eq true and isDeleted eq false',
          expand: {
            questions: { select: 'id,question,order' },
            responses: { select: 'id,response,order' },
          },
        },
        groups: {
          filter: 'isActive eq true',
        },
      },
    },
  },
  filter: 'isActive eq true',
};
